export const testimonials = [
  {
    id: "t-1",
    name: "老李",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20middle%20aged%20man%20portrait%20in%20casual%20wear%2C%20warm%20lighting%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20professional%20headshot%20style&width=200&height=200&seq=avatar-t1&orientation=squarish",
    content: "这个平台的信息真的太及时了！很多其他媒体看不到的内幕，在这里都能第一时间了解到。编辑团队的专业度让人佩服。",
    role: "资深媒体人",
    rating: 5,
  },
  {
    id: "t-2",
    name: "小王",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20glasses%2C%20modern%20professional%20look%2C%20soft%20natural%20lighting%2C%20clean%20white%20background%2C%20headshot%20photography&width=200&height=200&seq=avatar-t2&orientation=squarish",
    content: "每天必刷的资讯平台，深度分析文章特别有料。不像其他网站只会复制粘贴，这里的原创内容质量很高。",
    role: "互联网从业者",
    rating: 5,
  },
  {
    id: "t-3",
    name: "阿强",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20man%20in%20his%2030s%20portrait%2C%20confident%20expression%2C%20dark%20hair%2C%20casual%20business%20attire%2C%20clean%20studio%20lighting%2C%20professional%20headshot&width=200&height=200&seq=avatar-t3&orientation=squarish",
    content: "自从发现了黑料社区，我的信息渠道彻底打开了。很多行业内的潜规则和灰色地带，这里都有深度剖析。推荐给所有关心社会的朋友。",
    role: "自媒体博主",
    rating: 4,
  },
  {
    id: "t-4",
    name: "芳姐",
    avatar: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20woman%20in%2040s%20portrait%2C%20warm%20smile%2C%20short%20hair%2C%20natural%20makeup%2C%20clean%20white%20background%2C%20professional%20headshot%20photography&width=200&height=200&seq=avatar-t4&orientation=squarish",
    content: "黑料社区的评论区氛围也很好，大家都在理性讨论，没有无脑喷子。这种社区氛围在现在的互联网上真的很难得。",
    role: "企业高管",
    rating: 5,
  },
  {
    id: "t-5",
    name: "大刘",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%2C%20stylish%20casual%20look%2C%20confident%20smile%2C%20studio%20lighting%2C%20clean%20gray%20background%2C%20editorial%20portrait&width=200&height=200&seq=avatar-t5&orientation=squarish",
    content: "作为一个新闻专业的学生，这里的深度报道给我很多启发。文章结构清晰，事实核查严谨，是学习的好范本。",
    role: "新闻系学生",
    rating: 5,
  },
  {
    id: "t-6",
    name: "陈姐",
    avatar: "https://readdy.ai/api/search-image?query=Mature%20Chinese%20woman%20portrait%2C%20gentle%20smile%2C%20professional%20attire%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20headshot%20photography&width=200&height=200&seq=avatar-t6&orientation=squarish",
    content: "终于找到一个不用翻墙也能看到深度资讯的地方了。更新频率也很快，基本每天都有新内容可以看。",
    role: "自由职业者",
    rating: 4,
  },
];